import React from 'react';
import { useTranslation } from 'react-i18next';

import Checkbox from 'component/Layout/Form/Checkbox';
import Toggle from 'component/Layout/Toggle';

import classNames from 'classnames';

import { ReactComponent as IconChevronRounded } from 'media/svg/chevronRounded.svg';

import { isTablet } from 'utility/Check/Device';

import { Iata } from 'types/Search/airport';

import { regionMap } from '../../__config/mapping';
import { useAirportAutocompleterState } from '../../__context';
import { getAirportLabel, getSortedAirportList } from '../../__helper/airport';
import { Country, Region as RegionType, RegionAirportList } from '../../types';
import styles from '../Airport.module.scss';

import Airport from './Airport';

interface RegionListProps {
    list: RegionAirportList[];
    country: Country;
    onAirportClick: (entry: Iata) => void;
    onRegionClick: (
        country: Country,
        isChecked: boolean,
        region: RegionType
    ) => void;
}

const Region = ({
    list,
    country,
    onAirportClick,
    onRegionClick,
}: RegionListProps) => {
    const { t } = useTranslation();
    const { currentValue } = useAirportAutocompleterState();

    return (
        <div className={classNames(styles.RegionList, styles.SubLevel)}>
            {list.map((currentRegion) => {
                const { iataCodeList, region } = currentRegion;
                const airportList = getSortedAirportList(iataCodeList, t);
                const isChecked = airportList.every((code) =>
                    currentValue.has(code)
                );
                const regionTranslation = t(regionMap[region]);
                const labelList = airportList
                    .map((code) => t(getAirportLabel(code)))
                    .join(', ');
                return (
                    <div key={region} className={styles.VerticalLine}>
                        <Toggle
                            customClassList={{
                                More: styles.More,
                                Open: styles.Open,
                                Toggle: classNames(styles.Toggle, {
                                    [styles.Tablet]: isTablet(),
                                }),
                            }}
                            opener={''}
                            closer={''}
                            icon={<IconChevronRounded />}
                            iconPosition={'before'}
                            hiddenChild={
                                <Airport
                                    list={airportList}
                                    onChange={onAirportClick}
                                    idPrefix={'top-'}
                                />
                            }
                        >
                            <Checkbox
                                input={{
                                    name: regionTranslation,
                                    id: regionTranslation,
                                    value: regionTranslation,
                                }}
                                customClass={{
                                    Label: styles.ListItemContent,
                                    Wrapper: classNames(styles.ListItem, {
                                        [styles.Tablet]: isTablet(),
                                    }),
                                }}
                                onClick={() => {
                                    onRegionClick?.(country, isChecked, region);
                                }}
                                key={regionTranslation}
                                onChange={() => {}}
                                isChecked={isChecked}
                            >
                                <span>{regionTranslation}</span>
                                <span className={styles.SubLabel}>
                                    {labelList}
                                </span>
                            </Checkbox>
                        </Toggle>
                    </div>
                );
            })}
            <div className={styles.Divider} />
        </div>
    );
};

export default Region;
